"use client";

import React from "react";
import { LocationProps } from "./props";
import Link from "next/link";
import { getCookie } from "cookies-next";
import {
  PostHostEventsEnum,
  sendPostHogEvent,
} from "../../libs/post-hog/post-hog-send-event";

export const Location = ({ address, vehicle }: LocationProps) => {
  const googleMapsLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    address
  )}`;

  const handleClickGoNow = async () => {
    const email = (await getCookie("leadEmail")) ?? undefined;

    sendPostHogEvent({
      eventName: PostHostEventsEnum.LOCATION_EVENT,
      email: email,
      eventProperties: {
        ref: "Go Now",
        email: email ? email : undefined,
        ...vehicle,
      },
    });
  };

  return (
    <div className="mt-12 border-b border-gray-300 pb-12">
      <h3 className="mb-5 font-medium text-xl tracking-wide">Localização</h3>
      <Link
        href={googleMapsLink}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium cursor-pointer transition duration-300 text-sm mb-6 text-blue-600 hover:text-blue-800 flex items-center gap-2 max-w-40"
        onClick={handleClickGoNow}
      >
        Ir Agora
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          className="align-middle ml-2 -translate-y-[1px]"
        >
          <g clipPath="url(#clip0_881_14440)">
            <path
              d="M14.1111 0H5.55558C5.34062 0 5.16668 0.173943 5.16668 0.388901C5.16668 0.603859 5.34062 0.777802 5.55558 0.777802H13.1723L0.613941 13.3362C0.46202 13.4881 0.46202 13.7342 0.613941 13.8861C0.689884 13.962 0.789415 14 0.88891 14C0.988405 14 1.0879 13.962 1.16388 13.8861L13.7222 1.3277V8.94447C13.7222 9.15943 13.8962 9.33337 14.1111 9.33337C14.3261 9.33337 14.5 9.15943 14.5 8.94447V0.388901C14.5 0.173943 14.3261 0 14.1111 0Z"
              fill="#405FF2"
            ></path>
          </g>
        </svg>
      </Link>
      <div>
        <iframe
          src={`https://maps.google.com/maps?q=${encodeURIComponent(
            address
          )}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}
          className="w-full h-[450px] rounded-2xl"
          sandbox="allow-scripts allow-same-origin"
          title="Google Maps Location"
          referrerPolicy="no-referrer"
        ></iframe>
      </div>
    </div>
  );
};
